import { render, staticRenderFns } from "./EiProductDetail.vue?vue&type=template&id=b5156e10&"
import script from "./EiProductDetail.vue?vue&type=script&lang=js&"
export * from "./EiProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./EiProductDetail.vue?vue&type=style&index=0&lang=scss&slot-scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EiProductDetail.vue"
export default component.exports